module.exports = __webpack_public_path__ + "img/SES_CS-SLIMLINER-Repairing.c6800147.jpg";